// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Debt Snowball Component Styles */

.debt-snowball {
  min-height: 100vh;
  background: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);
  color: var(--gray-800);
  padding-bottom: 100px;
}

/* Header */
.debt-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 72px;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: var(--shadow-lg);
  z-index: 100;
  backdrop-filter: blur(20px);
}

.debt-header h1 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--white);
  letter-spacing: -0.025em;
  flex: 1 1;
  text-align: center;
}

.back-button,
.add-button {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  padding: 12px 16px;
  cursor: pointer;
  color: var(--white);
  border-radius: 12px;
  transition: var(--transition);
  backdrop-filter: blur(10px);
  font-size: 16px;
  font-weight: 600;
}

.back-button:hover,
.add-button:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
}

.back-button:active,
.add-button:active {
  transform: scale(0.95);
}

.add-button {
  font-size: 24px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Summary Section */
.debt-summary {
  margin-top: 88px;
  padding: 24px 20px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.summary-card {
  background: var(--white);
  padding: 20px 16px;
  border-radius: var(--border-radius);
  text-align: center;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--gray-200);
  transition: var(--transition);
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.summary-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--gray-500);
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.summary-value {
  font-size: 16px;
  font-weight: 800;
  color: var(--gray-800);
  letter-spacing: -0.025em;
}

/* Extra Payment Section */
.extra-payment-section {
  padding: 24px 20px;
  background: var(--white);
  margin: 16px 20px;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--gray-200);
}

.extra-payment-section h3 {
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--gray-800);
}

.input-with-symbol {
  display: flex;
  align-items: center;
  background: var(--gray-50);
  border-radius: var(--border-radius);
  border: 2px solid var(--gray-200);
  overflow: hidden;
  transition: var(--transition);
}

.input-with-symbol:focus-within {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.input-with-symbol span {
  color: var(--gray-500);
  background: var(--gray-100);
  padding: 16px 20px;
  font-weight: 600;
  font-size: 16px;
}

.input-with-symbol input {
  border: none;
  padding: 16px 20px;
  width: 100%;
  font-size: 16px;
  background: transparent;
  color: var(--gray-800);
  font-weight: 500;
}

.input-with-symbol input:focus {
  outline: none;
}

/* Action Buttons */
.action-buttons {
  padding: 0 20px;
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
}

.import-button,
.schedule-button {
  flex: 1 1;
  padding: 16px 24px;
  border: none;
  border-radius: var(--border-radius);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  text-align: center;
}

.import-button {
  background: linear-gradient(135deg, var(--secondary-color) 0%, #059669 100%);
  color: var(--white);
  box-shadow: var(--shadow-sm);
}

.import-button:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.schedule-button {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  color: var(--white);
  box-shadow: var(--shadow-sm);
}

.schedule-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.schedule-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
}

/* Debt Cards */
.debt-cards {
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.debt-card {
  background: var(--white);
  border-radius: var(--border-radius-lg);
  padding: 24px;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--gray-200);
  transition: var(--transition);
  position: relative;
  overflow: hidden;
}

.debt-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.debt-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.debt-card-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--gray-800);
  letter-spacing: -0.025em;
}

.edit-button {
  background: var(--gray-100);
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: var(--transition);
  font-size: 16px;
}

.edit-button:hover {
  background: var(--gray-200);
  transform: scale(1.1);
}

.debt-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid var(--gray-100);
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-row span:first-child {
  font-weight: 500;
  color: var(--gray-600);
}

.detail-row span:last-child {
  font-weight: 600;
  color: var(--gray-800);
}

.detail-row .balance {
  font-weight: 800;
  color: var(--danger-color);
  font-size: 16px;
}

.detail-row .payoff-date {
  color: var(--secondary-color);
  font-weight: 700;
}

.debt-actions {
  display: flex;
  justify-content: flex-end;
}

.remove-button {
  background: var(--danger-color);
  color: var(--white);
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.remove-button:hover {
  background: #dc2626;
  transform: translateY(-1px);
}

/* Paid Off Debt Card */
.debt-card.paid-off {
  background: var(--gray-50);
  border-color: var(--gray-300);
  transform: scale(0.98);
  opacity: 0.7;
}

.paid-off-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(16, 185, 129, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.paid-stamp {
  background: var(--secondary-color);
  color: var(--white);
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 800;
  font-size: 18px;
  letter-spacing: 0.1em;
  text-align: center;
  transform: rotate(-15deg);
  box-shadow: var(--shadow-lg);
  border: 3px solid var(--white);
}

/* Shredded Paper Effect */
.shredded-effect {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    transparent 5%,
    rgba(0, 0, 0, 0.1) 5%,
    rgba(0, 0, 0, 0.1) 7%,
    transparent 7%,
    transparent 12%,
    rgba(0, 0, 0, 0.1) 12%,
    rgba(0, 0, 0, 0.1) 14%,
    transparent 14%,
    transparent 19%,
    rgba(0, 0, 0, 0.1) 19%,
    rgba(0, 0, 0, 0.1) 21%,
    transparent 21%,
    transparent 26%,
    rgba(0, 0, 0, 0.1) 26%,
    rgba(0, 0, 0, 0.1) 28%,
    transparent 28%,
    transparent 33%,
    rgba(0, 0, 0, 0.1) 33%,
    rgba(0, 0, 0, 0.1) 35%,
    transparent 35%,
    transparent 40%,
    rgba(0, 0, 0, 0.1) 40%,
    rgba(0, 0, 0, 0.1) 42%,
    transparent 42%,
    transparent 47%,
    rgba(0, 0, 0, 0.1) 47%,
    rgba(0, 0, 0, 0.1) 49%,
    transparent 49%,
    transparent 54%,
    rgba(0, 0, 0, 0.1) 54%,
    rgba(0, 0, 0, 0.1) 56%,
    transparent 56%,
    transparent 61%,
    rgba(0, 0, 0, 0.1) 61%,
    rgba(0, 0, 0, 0.1) 63%,
    transparent 63%,
    transparent 68%,
    rgba(0, 0, 0, 0.1) 68%,
    rgba(0, 0, 0, 0.1) 70%,
    transparent 70%,
    transparent 75%,
    rgba(0, 0, 0, 0.1) 75%,
    rgba(0, 0, 0, 0.1) 77%,
    transparent 77%,
    transparent 82%,
    rgba(0, 0, 0, 0.1) 82%,
    rgba(0, 0, 0, 0.1) 84%,
    transparent 84%,
    transparent 89%,
    rgba(0, 0, 0, 0.1) 89%,
    rgba(0, 0, 0, 0.1) 91%,
    transparent 91%,
    transparent 96%,
    rgba(0, 0, 0, 0.1) 96%,
    rgba(0, 0, 0, 0.1) 98%,
    transparent 98%,
    transparent 100%
  );
  animation: shredAnimation 2s ease-in-out;
}

@keyframes shredAnimation {
  0% {
    opacity: 0;
    transform: scaleY(0);
  }
  50% {
    opacity: 1;
    transform: scaleY(1) rotateZ(1deg);
  }
  100% {
    opacity: 0.3;
    transform: scaleY(1) rotateZ(0deg);
  }
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: var(--gray-500);
}

.empty-state h3 {
  margin: 0 0 12px 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--gray-600);
}

.empty-state p {
  margin: 0;
  font-size: 16px;
}

/* Dialog Styles */
.mobile-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
  padding: 16px;
  box-sizing: border-box;
}

.dialog-content {
  background: var(--white);
  width: 100%;
  max-width: 400px;
  border-radius: var(--border-radius-lg);
  padding: 32px 24px;
  box-shadow: var(--shadow-xl);
  animation: scaleIn 0.3s ease-out;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  position: relative;
}

.dialog-content h3 {
  margin: 0 0 24px 0;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  color: var(--gray-800);
}

.dialog-content input,
.dialog-content select {
  width: 100%;
  padding: 16px 20px;
  border: 2px solid var(--gray-200);
  border-radius: var(--border-radius);
  font-size: 16px;
  margin-bottom: 16px;
  background: var(--white);
  color: var(--gray-800);
  transition: var(--transition);
  box-sizing: border-box;
}

.dialog-content input:focus,
.dialog-content select:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.dialog-buttons {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.dialog-buttons button {
  flex: 1 1;
  padding: 16px 24px;
  border: none;
  border-radius: var(--border-radius);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.dialog-buttons button:first-child {
  background: var(--gray-100);
  color: var(--gray-700);
}

.dialog-buttons button:first-child:hover {
  background: var(--gray-200);
}

.dialog-buttons button:last-child {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  color: var(--white);
}

.dialog-buttons button:last-child:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.dialog-buttons button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
}

/* Bills List in Import Dialog */
.bills-list {
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 20px;
}

.bill-checkbox {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  margin-bottom: 8px;
  background: var(--gray-50);
  border-radius: 8px;
  cursor: pointer;
  transition: var(--transition);
}

.bill-checkbox:hover {
  background: var(--gray-100);
}

.bill-checkbox input[type="checkbox"] {
  width: 20px;
  height: 20px;
  margin: 0;
  accent-color: var(--primary-color);
}

.bill-checkbox span {
  flex: 1 1;
  font-size: 14px;
  color: var(--gray-700);
}

/* Enhanced Schedule Dialog */
.schedule-dialog .dialog-content {
  max-width: min(90vw, 800px);
  width: 100%;
  max-height: calc(100vh - 32px);
  padding: 20px 16px;
}

@media (min-width: 768px) {
  .schedule-dialog .dialog-content {
    max-width: 800px;
    padding: 32px 24px;
  }
}

@media (max-width: 480px) {
  .schedule-dialog .dialog-content {
    max-width: 100%;
    padding: 16px 12px;
    border-radius: var(--border-radius);
  }
}

.schedule-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.schedule-header button {
  background: none;
  border: none;
  font-size: 24px;
  color: var(--gray-500);
  cursor: pointer;
  padding: 4px;
  line-height: 1;
}

/* View Mode Selector */
.view-mode-selector {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-bottom: 24px;
  background: var(--gray-100);
  border-radius: var(--border-radius);
  padding: 4px;
}

.view-mode-btn {
  background: transparent;
  border: none;
  padding: 12px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  text-align: center;
  color: var(--gray-600);
}

.view-mode-btn:hover {
  background: var(--gray-200);
  color: var(--gray-800);
}

.view-mode-btn.active {
  background: var(--primary-color);
  color: var(--white);
  box-shadow: var(--shadow-sm);
}

.schedule-content {
  min-height: 300px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  overflow-x: hidden;
}

@media (min-width: 768px) {
  .schedule-content {
    min-height: 400px;
    max-height: calc(100vh - 250px);
  }
}

@media (max-width: 480px) {
  .schedule-content {
    min-height: 250px;
    max-height: calc(100vh - 150px);
  }
}

.schedule-list {
  max-height: 60vh;
  overflow-y: auto;
}

.schedule-month {
  margin-bottom: 24px;
  background: var(--gray-50);
  border-radius: var(--border-radius);
  padding: 20px;
  border: 1px solid var(--gray-200);
}

.month-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  font-weight: 700;
  color: var(--gray-800);
}

.month-debts {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}

.schedule-debt {
  background: var(--white);
  padding: 16px;
  border-radius: 8px;
  border: 1px solid var(--gray-200);
}

.debt-name {
  font-weight: 600;
  color: var(--gray-800);
  margin-bottom: 8px;
}

.debt-payment {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 14px;
  color: var(--gray-600);
  margin-bottom: 12px;
}

.paid-off-text {
  color: var(--secondary-color);
  font-weight: 700;
}

.mark-paid-button {
  background: var(--primary-color);
  color: var(--white);
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  width: 100%;
}

.mark-paid-button:hover:not(:disabled) {
  background: var(--primary-dark);
  transform: translateY(-1px);
}

.mark-paid-button.paid {
  background: var(--secondary-color);
  cursor: default;
}

.mark-paid-button:disabled {
  cursor: not-allowed;
  transform: none !important;
}

.month-total {
  text-align: right;
  font-weight: 700;
  color: var(--primary-color);
  border-top: 2px solid var(--gray-200);
  padding-top: 12px;
}

/* Timeline View */
.timeline-view {
  padding: 20px;
  position: relative;
  min-height: 400px;
}

@media (max-width: 768px) {
  .timeline-view {
    padding: 16px;
    min-height: 350px;
  }
}

@media (max-width: 480px) {
  .timeline-view {
    padding: 12px;
    min-height: 300px;
  }
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  font-weight: 700;
  color: var(--gray-800);
}

@media (max-width: 480px) {
  .timeline-header {
    margin-bottom: 20px;
    font-size: 14px;
  }
}

.timeline-start {
  color: var(--danger-color);
}

.timeline-end {
  color: var(--secondary-color);
}

.timeline-container {
  position: relative;
  min-height: 300px;
  padding-bottom: 60px;
}

@media (max-width: 768px) {
  .timeline-container {
    min-height: 250px;
    padding-bottom: 50px;
  }
}

@media (max-width: 480px) {
  .timeline-container {
    min-height: 200px;
    padding-bottom: 40px;
  }
}

.timeline-line {
  position: absolute;
  top: 0;
  left: 5%;
  right: 5%;
  height: 4px;
  background: linear-gradient(90deg, var(--danger-color) 0%, var(--secondary-color) 100%);
  border-radius: 2px;
  box-shadow: var(--shadow-sm);
}

.timeline-debt {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 12px;
}

.timeline-marker {
  width: 16px;
  height: 16px;
  background: var(--primary-color);
  border-radius: 50%;
  border: 3px solid var(--white);
  box-shadow: var(--shadow-md);
  z-index: 2;
}

.timeline-debt-info {
  background: var(--white);
  padding: 12px 16px;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--gray-200);
  min-width: 200px;
  max-width: 280px;
}

@media (max-width: 768px) {
  .timeline-debt-info {
    min-width: 160px;
    max-width: 220px;
    padding: 10px 12px;
  }
}

@media (max-width: 480px) {
  .timeline-debt-info {
    min-width: 140px;
    max-width: 180px;
    padding: 8px 10px;
  }
}

.timeline-debt-info .debt-name {
  font-weight: 700;
  color: var(--gray-800);
  margin-bottom: 4px;
  font-size: 14px;
  line-height: 1.2;
}

@media (max-width: 480px) {
  .timeline-debt-info .debt-name {
    font-size: 12px;
  }
}

.timeline-debt-info .debt-payoff {
  font-size: 11px;
  color: var(--gray-600);
  margin-bottom: 4px;
  line-height: 1.2;
}

@media (max-width: 480px) {
  .timeline-debt-info .debt-payoff {
    font-size: 10px;
  }
}

.timeline-debt-info .debt-balance {
  font-weight: 600;
  color: var(--danger-color);
  font-size: 13px;
}

@media (max-width: 480px) {
  .timeline-debt-info .debt-balance {
    font-size: 12px;
  }
}

.timeline-scale {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  padding: 0 5%;
}

.scale-mark {
  text-align: center;
}

.scale-number {
  font-size: 12px;
  color: var(--gray-500);
  font-weight: 500;
}

/* Progress View */
.progress-view {
  padding: 20px;
}

@media (max-width: 768px) {
  .progress-view {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .progress-view {
    padding: 12px;
  }
}

.progress-summary {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 30px;
}

@media (max-width: 480px) {
  .progress-summary {
    grid-template-columns: 1fr;
    gap: 12px;
    margin-bottom: 20px;
  }
}

.progress-stat {
  background: var(--gray-50);
  padding: 20px;
  border-radius: var(--border-radius);
  text-align: center;
  border: 1px solid var(--gray-200);
}

.stat-label {
  font-size: 12px;
  color: var(--gray-500);
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 500;
}

.stat-value {
  font-size: 18px;
  font-weight: 800;
  color: var(--gray-800);
}

.debt-progress-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.debt-progress-item {
  background: var(--white);
  padding: 20px;
  border-radius: var(--border-radius);
  border: 1px solid var(--gray-200);
  box-shadow: var(--shadow-sm);
}

.debt-progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.debt-progress-header .debt-name {
  font-weight: 700;
  color: var(--gray-800);
}

.debt-progress-header .debt-amount {
  font-weight: 700;
  color: var(--danger-color);
}

.progress-bar-container {
  margin-bottom: 8px;
}

.progress-bar {
  width: 100%;
  height: 12px;
  background: var(--gray-200);
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 8px;
}

.progress-fill {
  height: 100%;
  border-radius: 6px;
  transition: width 0.3s ease;
}

.progress-label {
  font-size: 14px;
  color: var(--gray-600);
}

.current-focus {
  color: var(--primary-color);
  font-weight: 700;
}

/* Chart View */
.chart-view {
  padding: 20px;
}

@media (max-width: 768px) {
  .chart-view {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .chart-view {
    padding: 12px;
  }
}

.chart-header {
  text-align: center;
  margin-bottom: 24px;
}

@media (max-width: 480px) {
  .chart-header {
    margin-bottom: 16px;
  }
}

.chart-header h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--gray-800);
}

@media (max-width: 480px) {
  .chart-header h4 {
    font-size: 16px;
  }
}

.chart-container {
  display: flex;
  align-items: stretch;
  margin-bottom: 20px;
  overflow-x: auto;
}

@media (max-width: 480px) {
  .chart-container {
    margin-bottom: 16px;
  }
}

.chart-y-axis {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 80px;
  padding-right: 12px;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .chart-y-axis {
    width: 70px;
    padding-right: 8px;
  }
}

@media (max-width: 480px) {
  .chart-y-axis {
    width: 60px;
    padding-right: 6px;
  }
}

.y-axis-label {
  font-size: 10px;
  color: var(--gray-500);
  text-align: right;
  line-height: 1.2;
}

@media (max-width: 480px) {
  .y-axis-label {
    font-size: 9px;
  }
}

.chart-area {
  flex: 1 1;
  background: var(--gray-50);
  border: 1px solid var(--gray-200);
  border-radius: var(--border-radius);
  padding: 10px;
  min-width: 250px;
}

@media (max-width: 480px) {
  .chart-area {
    padding: 8px;
    min-width: 200px;
  }
}

.debt-chart {
  width: 100%;
  height: 200px;
}

@media (max-width: 768px) {
  .debt-chart {
    height: 180px;
  }
}

@media (max-width: 480px) {
  .debt-chart {
    height: 150px;
  }
}

.chart-x-axis {
  display: flex;
  justify-content: space-between;
  margin-left: 92px;
  margin-top: 12px;
  overflow-x: auto;
}

@media (max-width: 768px) {
  .chart-x-axis {
    margin-left: 78px;
    margin-top: 10px;
  }
}

@media (max-width: 480px) {
  .chart-x-axis {
    margin-left: 66px;
    margin-top: 8px;
    flex-wrap: wrap;
    gap: 4px;
  }
}

.x-axis-label {
  font-size: 10px;
  color: var(--gray-500);
  text-align: center;
  white-space: nowrap;
}

@media (max-width: 480px) {
  .x-axis-label {
    font-size: 9px;
  }
}

.chart-legend {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--gray-600);
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

/* Enhanced List View */
.list-view {
  padding: 20px;
}

@media (max-width: 768px) {
  .list-view {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .list-view {
    padding: 12px;
  }
}

.list-summary {
  margin-bottom: 24px;
}

@media (max-width: 480px) {
  .list-summary {
    margin-bottom: 16px;
  }
}

.list-summary .summary-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.list-summary .summary-item {
  background: var(--gray-50);
  padding: 16px;
  border-radius: var(--border-radius);
  text-align: center;
  border: 1px solid var(--gray-200);
}

.list-summary .summary-label {
  font-size: 12px;
  color: var(--gray-500);
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 500;
}

.list-summary .summary-value {
  font-size: 16px;
  font-weight: 800;
  color: var(--gray-800);
}

.enhanced-schedule-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.enhanced-schedule-month {
  background: var(--white);
  border-radius: var(--border-radius);
  border: 1px solid var(--gray-200);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

.enhanced-schedule-month .month-header {
  background: var(--gray-50);
  padding: 16px 20px;
  border-bottom: 1px solid var(--gray-200);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media (max-width: 480px) {
  .enhanced-schedule-month .month-header {
    padding: 12px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

.month-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.month-number {
  font-weight: 700;
  color: var(--gray-800);
  font-size: 16px;
}

@media (max-width: 480px) {
  .month-number {
    font-size: 14px;
  }
}

.month-date {
  font-size: 12px;
  color: var(--gray-500);
}

@media (max-width: 480px) {
  .month-date {
    font-size: 11px;
  }
}

.month-summary {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: right;
}

@media (max-width: 480px) {
  .month-summary {
    text-align: left;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
  }
}

.month-payment {
  font-weight: 700;
  color: var(--primary-color);
  font-size: 16px;
}

@media (max-width: 480px) {
  .month-payment {
    font-size: 14px;
  }
}

.month-remaining {
  font-size: 12px;
  color: var(--gray-500);
}

@media (max-width: 480px) {
  .month-remaining {
    font-size: 11px;
  }
}

.enhanced-schedule-debt {
  padding: 16px 20px;
  border-bottom: 1px solid var(--gray-100);
}

@media (max-width: 480px) {
  .enhanced-schedule-debt {
    padding: 12px 16px;
  }
}

.enhanced-schedule-debt:last-child {
  border-bottom: none;
}

.enhanced-schedule-debt .debt-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.enhanced-schedule-debt .debt-name {
  font-weight: 600;
  color: var(--gray-800);
}

.paid-off-badge {
  background: var(--secondary-color);
  color: var(--white);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.debt-payment-details {
  background: var(--gray-50);
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 12px;
  border: 1px solid var(--gray-200);
}

@media (max-width: 480px) {
  .debt-payment-details {
    padding: 10px;
    margin-bottom: 10px;
  }
}

.payment-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  font-size: 14px;
}

.payment-row.total {
  border-top: 1px solid var(--gray-300);
  margin-top: 8px;
  padding-top: 8px;
  font-weight: 700;
  color: var(--primary-color);
}

/* Dialog Responsive Rules */
@media (max-width: 768px) {
  .mobile-dialog {
    padding: 12px;
  }
  
  .dialog-content {
    padding: 24px 16px;
  }
  
  .dialog-content h3 {
    font-size: 18px;
    margin-bottom: 20px;
  }
  
  .dialog-content input,
  .dialog-content select {
    padding: 14px 16px;
    font-size: 16px;
    margin-bottom: 14px;
  }
  
  .dialog-buttons {
    gap: 10px;
    margin-top: 20px;
  }
  
  .dialog-buttons button {
    padding: 14px 20px;
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .mobile-dialog {
    padding: 8px;
    align-items: flex-start;
    padding-top: 20px;
  }
  
  .dialog-content {
    padding: 20px 12px;
    max-height: calc(100vh - 40px);
    border-radius: 12px;
  }
  
  .dialog-content h3 {
    font-size: 16px;
    margin-bottom: 16px;
  }
  
  .dialog-content input,
  .dialog-content select {
    padding: 12px 14px;
    font-size: 16px;
    margin-bottom: 12px;
  }
  
  .dialog-buttons {
    gap: 8px;
    margin-top: 16px;
    flex-direction: column;
  }
  
  .dialog-buttons button {
    padding: 12px 16px;
    font-size: 14px;
    width: 100%;
  }
  
  .bills-list {
    max-height: 200px;
  }
  
  .bill-checkbox {
    padding: 10px 12px;
    margin-bottom: 6px;
  }
  
  .bill-checkbox span {
    font-size: 13px;
  }
}

/* Responsive Design */
@media (min-width: 768px) {
  .debt-snowball {
    max-width: 768px;
    margin: 0 auto;
  }
  
  .debt-header {
    max-width: 768px;
    left: 50%;
    transform: translateX(-50%);
  }
  
  .debt-summary {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .progress-summary {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .debt-summary {
    padding: 20px 16px;
  }
  
  .extra-payment-section {
    margin: 16px 16px;
  }
  
  .action-buttons {
    padding: 0 16px;
  }
  
  .debt-cards {
    padding: 0 16px;
  }
}

@media (max-width: 480px) {
  .debt-summary {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 16px 12px;
  }
  
  .action-buttons {
    flex-direction: column;
    padding: 0 12px;
  }
  
  .summary-value {
    font-size: 14px;
  }
  
  .summary-label {
    font-size: 11px;
  }
  
  .view-mode-selector {
    grid-template-columns: repeat(2, 1fr);
    gap: 4px;
  }
  
  .view-mode-btn {
    font-size: 11px;
    padding: 10px 6px;
  }
  
  .progress-summary {
    grid-template-columns: 1fr;
  }
  
  .extra-payment-section {
    margin: 12px;
    padding: 20px 16px;
  }
  
  .extra-payment-section h3 {
    font-size: 16px;
  }
  
  .debt-cards {
    padding: 0 12px;
  }
  
  .debt-card {
    padding: 20px 16px;
  }
  
  .debt-card-header h3 {
    font-size: 16px;
  }
  
  .empty-state {
    padding: 40px 16px;
  }
  
  .empty-state h3 {
    font-size: 18px;
  }
  
  .empty-state p {
    font-size: 14px;
  }
}

/* Dark Mode Support */
.dark-mode .debt-snowball {
  background: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);
}

.dark-mode .debt-header {
  background: linear-gradient(135deg, #422749 0%, #200f2a 100%);
}

.dark-mode .debt-header h1 {
	color: white !important;
}

.dark-mode .summary-card,
.dark-mode .extra-payment-section,
.dark-mode .debt-card {
  background: var(--white);
  border-color: var(--gray-200);
}

.dark-mode .input-with-symbol {
  background: var(--gray-100);
  border-color: var(--gray-200);
}

.dark-mode .input-with-symbol span {
  background: var(--gray-200);
}

.dark-mode .dialog-content {
  background: var(--white);
}

.dark-mode .dialog-content input,
.dark-mode .dialog-content select {
  background: var(--gray-50);
  border-color: var(--gray-200);
}

.dark-mode .bill-checkbox {
  background: var(--gray-100);
}

.dark-mode .bill-checkbox:hover {
  background: var(--gray-200);
}

.dark-mode .schedule-month {
  background: var(--gray-100);
  border-color: var(--gray-200);
}

.dark-mode .schedule-debt {
  background: var(--gray-50);
  border-color: var(--gray-200);
}

.dark-mode .view-mode-selector {
  background: var(--gray-200);
}

.dark-mode .view-mode-btn {
  color: var(--gray-700);
}

.dark-mode .view-mode-btn:hover {
  background: var(--gray-300);
  color: var(--gray-800);
}

.dark-mode .timeline-debt-info,
.dark-mode .debt-progress-item,
.dark-mode .enhanced-schedule-month {
  background: var(--white);
  border-color: var(--gray-200);
}

.dark-mode .progress-stat,
.dark-mode .list-summary .summary-item {
  background: var(--gray-100);
  border-color: var(--gray-200);
}

.dark-mode .chart-area {
  background: var(--gray-100);
  border-color: var(--gray-200);
}

.dark-mode .debt-payment-details {
  background: var(--gray-100);
  border-color: var(--gray-200);
}

.dark-mode .enhanced-schedule-month .month-header {
  background: var(--gray-100);
  border-color: var(--gray-200);
}

/* Animation for debt card entry */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.debt-card {
  animation: slideInUp 0.3s ease-out;
}

/* Print Styles */
@media print {
  .debt-header,
  .action-buttons,
  .debt-actions,
  .edit-button,
  .remove-button {
    display: none !important;
  }
  
  .debt-snowball {
    background: var(--white);
    margin: 0;
    padding: 20px;
  }
  
  .debt-summary {
    margin-top: 0;
  }
  
  .debt-card {
    break-inside: avoid;
    page-break-inside: avoid;
    box-shadow: none;
    border: 1px solid var(--gray-300);
    margin-bottom: 20px;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/DebtSnowball.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,iBAAiB;EACjB,4EAA4E;EAC5E,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,sFAAsF;EACtF,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,4BAA4B;EAC5B,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,SAAO;EACP,kBAAkB;AACpB;;AAEA;;EAEE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,mCAAmC;EACnC,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,mCAAmC;EACnC,iCAAiC;EACjC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,4EAA4E;EAC5E,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,sFAAsF;EACtF,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA4DC;EACD,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,oBAAoB;EACtB;EACA;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,YAAY;IACZ,kCAAkC;EACpC;AACF;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,4BAA4B;EAC5B,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,mCAAmC;EACnC,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sFAAsF;EACtF,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,eAAe;EACf,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,2BAA2B;EAC3B,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,mCAAmC;EACrC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;IACjB,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,+BAA+B;EACjC;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,mCAAmC;EACnC,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,WAAW;EACX,uFAAuF;EACvF,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mCAAmC;EACnC,4BAA4B;EAC5B,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,mBAAmB;EACrB;AACF;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mCAAmC;EACnC,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,mCAAmC;EACnC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,SAAO;EACP,0BAA0B;EAC1B,iCAAiC;EACjC,mCAAmC;EACnC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,QAAQ;EACV;AACF;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mCAAmC;EACnC,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,iCAAiC;EACjC,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE,4EAA4E;AAC9E;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;CACC,uBAAuB;AACxB;;AAEA;;;EAGE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;;EAGE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;;EAEE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,kCAAkC;AAClC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA,iBAAiB;AACjB;EACE;;;;;IAKE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;EACrB;AACF","sourcesContent":["/* Debt Snowball Component Styles */\n\n.debt-snowball {\n  min-height: 100vh;\n  background: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);\n  color: var(--gray-800);\n  padding-bottom: 100px;\n}\n\n/* Header */\n.debt-header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 72px;\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n  box-shadow: var(--shadow-lg);\n  z-index: 100;\n  backdrop-filter: blur(20px);\n}\n\n.debt-header h1 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--white);\n  letter-spacing: -0.025em;\n  flex: 1;\n  text-align: center;\n}\n\n.back-button,\n.add-button {\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  padding: 12px 16px;\n  cursor: pointer;\n  color: var(--white);\n  border-radius: 12px;\n  transition: var(--transition);\n  backdrop-filter: blur(10px);\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.back-button:hover,\n.add-button:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: scale(1.05);\n}\n\n.back-button:active,\n.add-button:active {\n  transform: scale(0.95);\n}\n\n.add-button {\n  font-size: 24px;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Summary Section */\n.debt-summary {\n  margin-top: 88px;\n  padding: 24px 20px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n}\n\n.summary-card {\n  background: var(--white);\n  padding: 20px 16px;\n  border-radius: var(--border-radius);\n  text-align: center;\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--gray-200);\n  transition: var(--transition);\n}\n\n.summary-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.summary-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--gray-500);\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.summary-value {\n  font-size: 16px;\n  font-weight: 800;\n  color: var(--gray-800);\n  letter-spacing: -0.025em;\n}\n\n/* Extra Payment Section */\n.extra-payment-section {\n  padding: 24px 20px;\n  background: var(--white);\n  margin: 16px 20px;\n  border-radius: var(--border-radius);\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--gray-200);\n}\n\n.extra-payment-section h3 {\n  margin: 0 0 16px 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--gray-800);\n}\n\n.input-with-symbol {\n  display: flex;\n  align-items: center;\n  background: var(--gray-50);\n  border-radius: var(--border-radius);\n  border: 2px solid var(--gray-200);\n  overflow: hidden;\n  transition: var(--transition);\n}\n\n.input-with-symbol:focus-within {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n.input-with-symbol span {\n  color: var(--gray-500);\n  background: var(--gray-100);\n  padding: 16px 20px;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.input-with-symbol input {\n  border: none;\n  padding: 16px 20px;\n  width: 100%;\n  font-size: 16px;\n  background: transparent;\n  color: var(--gray-800);\n  font-weight: 500;\n}\n\n.input-with-symbol input:focus {\n  outline: none;\n}\n\n/* Action Buttons */\n.action-buttons {\n  padding: 0 20px;\n  display: flex;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.import-button,\n.schedule-button {\n  flex: 1;\n  padding: 16px 24px;\n  border: none;\n  border-radius: var(--border-radius);\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n  text-align: center;\n}\n\n.import-button {\n  background: linear-gradient(135deg, var(--secondary-color) 0%, #059669 100%);\n  color: var(--white);\n  box-shadow: var(--shadow-sm);\n}\n\n.import-button:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.schedule-button {\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);\n  color: var(--white);\n  box-shadow: var(--shadow-sm);\n}\n\n.schedule-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.schedule-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n/* Debt Cards */\n.debt-cards {\n  padding: 0 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.debt-card {\n  background: var(--white);\n  border-radius: var(--border-radius-lg);\n  padding: 24px;\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--gray-200);\n  transition: var(--transition);\n  position: relative;\n  overflow: hidden;\n}\n\n.debt-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.debt-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.debt-card-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--gray-800);\n  letter-spacing: -0.025em;\n}\n\n.edit-button {\n  background: var(--gray-100);\n  border: none;\n  padding: 8px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: var(--transition);\n  font-size: 16px;\n}\n\n.edit-button:hover {\n  background: var(--gray-200);\n  transform: scale(1.1);\n}\n\n.debt-details {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--gray-100);\n}\n\n.detail-row:last-child {\n  border-bottom: none;\n}\n\n.detail-row span:first-child {\n  font-weight: 500;\n  color: var(--gray-600);\n}\n\n.detail-row span:last-child {\n  font-weight: 600;\n  color: var(--gray-800);\n}\n\n.detail-row .balance {\n  font-weight: 800;\n  color: var(--danger-color);\n  font-size: 16px;\n}\n\n.detail-row .payoff-date {\n  color: var(--secondary-color);\n  font-weight: 700;\n}\n\n.debt-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.remove-button {\n  background: var(--danger-color);\n  color: var(--white);\n  border: none;\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.remove-button:hover {\n  background: #dc2626;\n  transform: translateY(-1px);\n}\n\n/* Paid Off Debt Card */\n.debt-card.paid-off {\n  background: var(--gray-50);\n  border-color: var(--gray-300);\n  transform: scale(0.98);\n  opacity: 0.7;\n}\n\n.paid-off-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(16, 185, 129, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n.paid-stamp {\n  background: var(--secondary-color);\n  color: var(--white);\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-weight: 800;\n  font-size: 18px;\n  letter-spacing: 0.1em;\n  text-align: center;\n  transform: rotate(-15deg);\n  box-shadow: var(--shadow-lg);\n  border: 3px solid var(--white);\n}\n\n/* Shredded Paper Effect */\n.shredded-effect {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    transparent 5%,\n    rgba(0, 0, 0, 0.1) 5%,\n    rgba(0, 0, 0, 0.1) 7%,\n    transparent 7%,\n    transparent 12%,\n    rgba(0, 0, 0, 0.1) 12%,\n    rgba(0, 0, 0, 0.1) 14%,\n    transparent 14%,\n    transparent 19%,\n    rgba(0, 0, 0, 0.1) 19%,\n    rgba(0, 0, 0, 0.1) 21%,\n    transparent 21%,\n    transparent 26%,\n    rgba(0, 0, 0, 0.1) 26%,\n    rgba(0, 0, 0, 0.1) 28%,\n    transparent 28%,\n    transparent 33%,\n    rgba(0, 0, 0, 0.1) 33%,\n    rgba(0, 0, 0, 0.1) 35%,\n    transparent 35%,\n    transparent 40%,\n    rgba(0, 0, 0, 0.1) 40%,\n    rgba(0, 0, 0, 0.1) 42%,\n    transparent 42%,\n    transparent 47%,\n    rgba(0, 0, 0, 0.1) 47%,\n    rgba(0, 0, 0, 0.1) 49%,\n    transparent 49%,\n    transparent 54%,\n    rgba(0, 0, 0, 0.1) 54%,\n    rgba(0, 0, 0, 0.1) 56%,\n    transparent 56%,\n    transparent 61%,\n    rgba(0, 0, 0, 0.1) 61%,\n    rgba(0, 0, 0, 0.1) 63%,\n    transparent 63%,\n    transparent 68%,\n    rgba(0, 0, 0, 0.1) 68%,\n    rgba(0, 0, 0, 0.1) 70%,\n    transparent 70%,\n    transparent 75%,\n    rgba(0, 0, 0, 0.1) 75%,\n    rgba(0, 0, 0, 0.1) 77%,\n    transparent 77%,\n    transparent 82%,\n    rgba(0, 0, 0, 0.1) 82%,\n    rgba(0, 0, 0, 0.1) 84%,\n    transparent 84%,\n    transparent 89%,\n    rgba(0, 0, 0, 0.1) 89%,\n    rgba(0, 0, 0, 0.1) 91%,\n    transparent 91%,\n    transparent 96%,\n    rgba(0, 0, 0, 0.1) 96%,\n    rgba(0, 0, 0, 0.1) 98%,\n    transparent 98%,\n    transparent 100%\n  );\n  animation: shredAnimation 2s ease-in-out;\n}\n\n@keyframes shredAnimation {\n  0% {\n    opacity: 0;\n    transform: scaleY(0);\n  }\n  50% {\n    opacity: 1;\n    transform: scaleY(1) rotateZ(1deg);\n  }\n  100% {\n    opacity: 0.3;\n    transform: scaleY(1) rotateZ(0deg);\n  }\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: var(--gray-500);\n}\n\n.empty-state h3 {\n  margin: 0 0 12px 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--gray-600);\n}\n\n.empty-state p {\n  margin: 0;\n  font-size: 16px;\n}\n\n/* Dialog Styles */\n.mobile-dialog {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease-out;\n  padding: 16px;\n  box-sizing: border-box;\n}\n\n.dialog-content {\n  background: var(--white);\n  width: 100%;\n  max-width: 400px;\n  border-radius: var(--border-radius-lg);\n  padding: 32px 24px;\n  box-shadow: var(--shadow-xl);\n  animation: scaleIn 0.3s ease-out;\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n  position: relative;\n}\n\n.dialog-content h3 {\n  margin: 0 0 24px 0;\n  font-size: 20px;\n  font-weight: 700;\n  text-align: center;\n  color: var(--gray-800);\n}\n\n.dialog-content input,\n.dialog-content select {\n  width: 100%;\n  padding: 16px 20px;\n  border: 2px solid var(--gray-200);\n  border-radius: var(--border-radius);\n  font-size: 16px;\n  margin-bottom: 16px;\n  background: var(--white);\n  color: var(--gray-800);\n  transition: var(--transition);\n  box-sizing: border-box;\n}\n\n.dialog-content input:focus,\n.dialog-content select:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n.dialog-buttons {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.dialog-buttons button {\n  flex: 1;\n  padding: 16px 24px;\n  border: none;\n  border-radius: var(--border-radius);\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.dialog-buttons button:first-child {\n  background: var(--gray-100);\n  color: var(--gray-700);\n}\n\n.dialog-buttons button:first-child:hover {\n  background: var(--gray-200);\n}\n\n.dialog-buttons button:last-child {\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);\n  color: var(--white);\n}\n\n.dialog-buttons button:last-child:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.dialog-buttons button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n/* Bills List in Import Dialog */\n.bills-list {\n  max-height: 300px;\n  overflow-y: auto;\n  margin-bottom: 20px;\n}\n\n.bill-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  margin-bottom: 8px;\n  background: var(--gray-50);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.bill-checkbox:hover {\n  background: var(--gray-100);\n}\n\n.bill-checkbox input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  margin: 0;\n  accent-color: var(--primary-color);\n}\n\n.bill-checkbox span {\n  flex: 1;\n  font-size: 14px;\n  color: var(--gray-700);\n}\n\n/* Enhanced Schedule Dialog */\n.schedule-dialog .dialog-content {\n  max-width: min(90vw, 800px);\n  width: 100%;\n  max-height: calc(100vh - 32px);\n  padding: 20px 16px;\n}\n\n@media (min-width: 768px) {\n  .schedule-dialog .dialog-content {\n    max-width: 800px;\n    padding: 32px 24px;\n  }\n}\n\n@media (max-width: 480px) {\n  .schedule-dialog .dialog-content {\n    max-width: 100%;\n    padding: 16px 12px;\n    border-radius: var(--border-radius);\n  }\n}\n\n.schedule-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.schedule-header button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: var(--gray-500);\n  cursor: pointer;\n  padding: 4px;\n  line-height: 1;\n}\n\n/* View Mode Selector */\n.view-mode-selector {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  margin-bottom: 24px;\n  background: var(--gray-100);\n  border-radius: var(--border-radius);\n  padding: 4px;\n}\n\n.view-mode-btn {\n  background: transparent;\n  border: none;\n  padding: 12px 8px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n  text-align: center;\n  color: var(--gray-600);\n}\n\n.view-mode-btn:hover {\n  background: var(--gray-200);\n  color: var(--gray-800);\n}\n\n.view-mode-btn.active {\n  background: var(--primary-color);\n  color: var(--white);\n  box-shadow: var(--shadow-sm);\n}\n\n.schedule-content {\n  min-height: 300px;\n  max-height: calc(100vh - 200px);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n@media (min-width: 768px) {\n  .schedule-content {\n    min-height: 400px;\n    max-height: calc(100vh - 250px);\n  }\n}\n\n@media (max-width: 480px) {\n  .schedule-content {\n    min-height: 250px;\n    max-height: calc(100vh - 150px);\n  }\n}\n\n.schedule-list {\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.schedule-month {\n  margin-bottom: 24px;\n  background: var(--gray-50);\n  border-radius: var(--border-radius);\n  padding: 20px;\n  border: 1px solid var(--gray-200);\n}\n\n.month-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  font-weight: 700;\n  color: var(--gray-800);\n}\n\n.month-debts {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.schedule-debt {\n  background: var(--white);\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid var(--gray-200);\n}\n\n.debt-name {\n  font-weight: 600;\n  color: var(--gray-800);\n  margin-bottom: 8px;\n}\n\n.debt-payment {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 14px;\n  color: var(--gray-600);\n  margin-bottom: 12px;\n}\n\n.paid-off-text {\n  color: var(--secondary-color);\n  font-weight: 700;\n}\n\n.mark-paid-button {\n  background: var(--primary-color);\n  color: var(--white);\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n  width: 100%;\n}\n\n.mark-paid-button:hover:not(:disabled) {\n  background: var(--primary-dark);\n  transform: translateY(-1px);\n}\n\n.mark-paid-button.paid {\n  background: var(--secondary-color);\n  cursor: default;\n}\n\n.mark-paid-button:disabled {\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n.month-total {\n  text-align: right;\n  font-weight: 700;\n  color: var(--primary-color);\n  border-top: 2px solid var(--gray-200);\n  padding-top: 12px;\n}\n\n/* Timeline View */\n.timeline-view {\n  padding: 20px;\n  position: relative;\n  min-height: 400px;\n}\n\n@media (max-width: 768px) {\n  .timeline-view {\n    padding: 16px;\n    min-height: 350px;\n  }\n}\n\n@media (max-width: 480px) {\n  .timeline-view {\n    padding: 12px;\n    min-height: 300px;\n  }\n}\n\n.timeline-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  font-weight: 700;\n  color: var(--gray-800);\n}\n\n@media (max-width: 480px) {\n  .timeline-header {\n    margin-bottom: 20px;\n    font-size: 14px;\n  }\n}\n\n.timeline-start {\n  color: var(--danger-color);\n}\n\n.timeline-end {\n  color: var(--secondary-color);\n}\n\n.timeline-container {\n  position: relative;\n  min-height: 300px;\n  padding-bottom: 60px;\n}\n\n@media (max-width: 768px) {\n  .timeline-container {\n    min-height: 250px;\n    padding-bottom: 50px;\n  }\n}\n\n@media (max-width: 480px) {\n  .timeline-container {\n    min-height: 200px;\n    padding-bottom: 40px;\n  }\n}\n\n.timeline-line {\n  position: absolute;\n  top: 0;\n  left: 5%;\n  right: 5%;\n  height: 4px;\n  background: linear-gradient(90deg, var(--danger-color) 0%, var(--secondary-color) 100%);\n  border-radius: 2px;\n  box-shadow: var(--shadow-sm);\n}\n\n.timeline-debt {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.timeline-marker {\n  width: 16px;\n  height: 16px;\n  background: var(--primary-color);\n  border-radius: 50%;\n  border: 3px solid var(--white);\n  box-shadow: var(--shadow-md);\n  z-index: 2;\n}\n\n.timeline-debt-info {\n  background: var(--white);\n  padding: 12px 16px;\n  border-radius: var(--border-radius);\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--gray-200);\n  min-width: 200px;\n  max-width: 280px;\n}\n\n@media (max-width: 768px) {\n  .timeline-debt-info {\n    min-width: 160px;\n    max-width: 220px;\n    padding: 10px 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .timeline-debt-info {\n    min-width: 140px;\n    max-width: 180px;\n    padding: 8px 10px;\n  }\n}\n\n.timeline-debt-info .debt-name {\n  font-weight: 700;\n  color: var(--gray-800);\n  margin-bottom: 4px;\n  font-size: 14px;\n  line-height: 1.2;\n}\n\n@media (max-width: 480px) {\n  .timeline-debt-info .debt-name {\n    font-size: 12px;\n  }\n}\n\n.timeline-debt-info .debt-payoff {\n  font-size: 11px;\n  color: var(--gray-600);\n  margin-bottom: 4px;\n  line-height: 1.2;\n}\n\n@media (max-width: 480px) {\n  .timeline-debt-info .debt-payoff {\n    font-size: 10px;\n  }\n}\n\n.timeline-debt-info .debt-balance {\n  font-weight: 600;\n  color: var(--danger-color);\n  font-size: 13px;\n}\n\n@media (max-width: 480px) {\n  .timeline-debt-info .debt-balance {\n    font-size: 12px;\n  }\n}\n\n.timeline-scale {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 40px;\n  padding: 0 5%;\n}\n\n.scale-mark {\n  text-align: center;\n}\n\n.scale-number {\n  font-size: 12px;\n  color: var(--gray-500);\n  font-weight: 500;\n}\n\n/* Progress View */\n.progress-view {\n  padding: 20px;\n}\n\n@media (max-width: 768px) {\n  .progress-view {\n    padding: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .progress-view {\n    padding: 12px;\n  }\n}\n\n.progress-summary {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  margin-bottom: 30px;\n}\n\n@media (max-width: 480px) {\n  .progress-summary {\n    grid-template-columns: 1fr;\n    gap: 12px;\n    margin-bottom: 20px;\n  }\n}\n\n.progress-stat {\n  background: var(--gray-50);\n  padding: 20px;\n  border-radius: var(--border-radius);\n  text-align: center;\n  border: 1px solid var(--gray-200);\n}\n\n.stat-label {\n  font-size: 12px;\n  color: var(--gray-500);\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-weight: 500;\n}\n\n.stat-value {\n  font-size: 18px;\n  font-weight: 800;\n  color: var(--gray-800);\n}\n\n.debt-progress-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.debt-progress-item {\n  background: var(--white);\n  padding: 20px;\n  border-radius: var(--border-radius);\n  border: 1px solid var(--gray-200);\n  box-shadow: var(--shadow-sm);\n}\n\n.debt-progress-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.debt-progress-header .debt-name {\n  font-weight: 700;\n  color: var(--gray-800);\n}\n\n.debt-progress-header .debt-amount {\n  font-weight: 700;\n  color: var(--danger-color);\n}\n\n.progress-bar-container {\n  margin-bottom: 8px;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 12px;\n  background: var(--gray-200);\n  border-radius: 6px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.progress-fill {\n  height: 100%;\n  border-radius: 6px;\n  transition: width 0.3s ease;\n}\n\n.progress-label {\n  font-size: 14px;\n  color: var(--gray-600);\n}\n\n.current-focus {\n  color: var(--primary-color);\n  font-weight: 700;\n}\n\n/* Chart View */\n.chart-view {\n  padding: 20px;\n}\n\n@media (max-width: 768px) {\n  .chart-view {\n    padding: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .chart-view {\n    padding: 12px;\n  }\n}\n\n.chart-header {\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n@media (max-width: 480px) {\n  .chart-header {\n    margin-bottom: 16px;\n  }\n}\n\n.chart-header h4 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--gray-800);\n}\n\n@media (max-width: 480px) {\n  .chart-header h4 {\n    font-size: 16px;\n  }\n}\n\n.chart-container {\n  display: flex;\n  align-items: stretch;\n  margin-bottom: 20px;\n  overflow-x: auto;\n}\n\n@media (max-width: 480px) {\n  .chart-container {\n    margin-bottom: 16px;\n  }\n}\n\n.chart-y-axis {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 80px;\n  padding-right: 12px;\n  flex-shrink: 0;\n}\n\n@media (max-width: 768px) {\n  .chart-y-axis {\n    width: 70px;\n    padding-right: 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .chart-y-axis {\n    width: 60px;\n    padding-right: 6px;\n  }\n}\n\n.y-axis-label {\n  font-size: 10px;\n  color: var(--gray-500);\n  text-align: right;\n  line-height: 1.2;\n}\n\n@media (max-width: 480px) {\n  .y-axis-label {\n    font-size: 9px;\n  }\n}\n\n.chart-area {\n  flex: 1;\n  background: var(--gray-50);\n  border: 1px solid var(--gray-200);\n  border-radius: var(--border-radius);\n  padding: 10px;\n  min-width: 250px;\n}\n\n@media (max-width: 480px) {\n  .chart-area {\n    padding: 8px;\n    min-width: 200px;\n  }\n}\n\n.debt-chart {\n  width: 100%;\n  height: 200px;\n}\n\n@media (max-width: 768px) {\n  .debt-chart {\n    height: 180px;\n  }\n}\n\n@media (max-width: 480px) {\n  .debt-chart {\n    height: 150px;\n  }\n}\n\n.chart-x-axis {\n  display: flex;\n  justify-content: space-between;\n  margin-left: 92px;\n  margin-top: 12px;\n  overflow-x: auto;\n}\n\n@media (max-width: 768px) {\n  .chart-x-axis {\n    margin-left: 78px;\n    margin-top: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .chart-x-axis {\n    margin-left: 66px;\n    margin-top: 8px;\n    flex-wrap: wrap;\n    gap: 4px;\n  }\n}\n\n.x-axis-label {\n  font-size: 10px;\n  color: var(--gray-500);\n  text-align: center;\n  white-space: nowrap;\n}\n\n@media (max-width: 480px) {\n  .x-axis-label {\n    font-size: 9px;\n  }\n}\n\n.chart-legend {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--gray-600);\n}\n\n.legend-color {\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n}\n\n/* Enhanced List View */\n.list-view {\n  padding: 20px;\n}\n\n@media (max-width: 768px) {\n  .list-view {\n    padding: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .list-view {\n    padding: 12px;\n  }\n}\n\n.list-summary {\n  margin-bottom: 24px;\n}\n\n@media (max-width: 480px) {\n  .list-summary {\n    margin-bottom: 16px;\n  }\n}\n\n.list-summary .summary-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n}\n\n.list-summary .summary-item {\n  background: var(--gray-50);\n  padding: 16px;\n  border-radius: var(--border-radius);\n  text-align: center;\n  border: 1px solid var(--gray-200);\n}\n\n.list-summary .summary-label {\n  font-size: 12px;\n  color: var(--gray-500);\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-weight: 500;\n}\n\n.list-summary .summary-value {\n  font-size: 16px;\n  font-weight: 800;\n  color: var(--gray-800);\n}\n\n.enhanced-schedule-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.enhanced-schedule-month {\n  background: var(--white);\n  border-radius: var(--border-radius);\n  border: 1px solid var(--gray-200);\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n}\n\n.enhanced-schedule-month .month-header {\n  background: var(--gray-50);\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--gray-200);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n@media (max-width: 480px) {\n  .enhanced-schedule-month .month-header {\n    padding: 12px 16px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n}\n\n.month-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.month-number {\n  font-weight: 700;\n  color: var(--gray-800);\n  font-size: 16px;\n}\n\n@media (max-width: 480px) {\n  .month-number {\n    font-size: 14px;\n  }\n}\n\n.month-date {\n  font-size: 12px;\n  color: var(--gray-500);\n}\n\n@media (max-width: 480px) {\n  .month-date {\n    font-size: 11px;\n  }\n}\n\n.month-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  text-align: right;\n}\n\n@media (max-width: 480px) {\n  .month-summary {\n    text-align: left;\n    width: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n}\n\n.month-payment {\n  font-weight: 700;\n  color: var(--primary-color);\n  font-size: 16px;\n}\n\n@media (max-width: 480px) {\n  .month-payment {\n    font-size: 14px;\n  }\n}\n\n.month-remaining {\n  font-size: 12px;\n  color: var(--gray-500);\n}\n\n@media (max-width: 480px) {\n  .month-remaining {\n    font-size: 11px;\n  }\n}\n\n.enhanced-schedule-debt {\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--gray-100);\n}\n\n@media (max-width: 480px) {\n  .enhanced-schedule-debt {\n    padding: 12px 16px;\n  }\n}\n\n.enhanced-schedule-debt:last-child {\n  border-bottom: none;\n}\n\n.enhanced-schedule-debt .debt-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.enhanced-schedule-debt .debt-name {\n  font-weight: 600;\n  color: var(--gray-800);\n}\n\n.paid-off-badge {\n  background: var(--secondary-color);\n  color: var(--white);\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.debt-payment-details {\n  background: var(--gray-50);\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  border: 1px solid var(--gray-200);\n}\n\n@media (max-width: 480px) {\n  .debt-payment-details {\n    padding: 10px;\n    margin-bottom: 10px;\n  }\n}\n\n.payment-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px 0;\n  font-size: 14px;\n}\n\n.payment-row.total {\n  border-top: 1px solid var(--gray-300);\n  margin-top: 8px;\n  padding-top: 8px;\n  font-weight: 700;\n  color: var(--primary-color);\n}\n\n/* Dialog Responsive Rules */\n@media (max-width: 768px) {\n  .mobile-dialog {\n    padding: 12px;\n  }\n  \n  .dialog-content {\n    padding: 24px 16px;\n  }\n  \n  .dialog-content h3 {\n    font-size: 18px;\n    margin-bottom: 20px;\n  }\n  \n  .dialog-content input,\n  .dialog-content select {\n    padding: 14px 16px;\n    font-size: 16px;\n    margin-bottom: 14px;\n  }\n  \n  .dialog-buttons {\n    gap: 10px;\n    margin-top: 20px;\n  }\n  \n  .dialog-buttons button {\n    padding: 14px 20px;\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .mobile-dialog {\n    padding: 8px;\n    align-items: flex-start;\n    padding-top: 20px;\n  }\n  \n  .dialog-content {\n    padding: 20px 12px;\n    max-height: calc(100vh - 40px);\n    border-radius: 12px;\n  }\n  \n  .dialog-content h3 {\n    font-size: 16px;\n    margin-bottom: 16px;\n  }\n  \n  .dialog-content input,\n  .dialog-content select {\n    padding: 12px 14px;\n    font-size: 16px;\n    margin-bottom: 12px;\n  }\n  \n  .dialog-buttons {\n    gap: 8px;\n    margin-top: 16px;\n    flex-direction: column;\n  }\n  \n  .dialog-buttons button {\n    padding: 12px 16px;\n    font-size: 14px;\n    width: 100%;\n  }\n  \n  .bills-list {\n    max-height: 200px;\n  }\n  \n  .bill-checkbox {\n    padding: 10px 12px;\n    margin-bottom: 6px;\n  }\n  \n  .bill-checkbox span {\n    font-size: 13px;\n  }\n}\n\n/* Responsive Design */\n@media (min-width: 768px) {\n  .debt-snowball {\n    max-width: 768px;\n    margin: 0 auto;\n  }\n  \n  .debt-header {\n    max-width: 768px;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  \n  .debt-summary {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  \n  .progress-summary {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .debt-summary {\n    padding: 20px 16px;\n  }\n  \n  .extra-payment-section {\n    margin: 16px 16px;\n  }\n  \n  .action-buttons {\n    padding: 0 16px;\n  }\n  \n  .debt-cards {\n    padding: 0 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .debt-summary {\n    grid-template-columns: 1fr;\n    gap: 12px;\n    padding: 16px 12px;\n  }\n  \n  .action-buttons {\n    flex-direction: column;\n    padding: 0 12px;\n  }\n  \n  .summary-value {\n    font-size: 14px;\n  }\n  \n  .summary-label {\n    font-size: 11px;\n  }\n  \n  .view-mode-selector {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 4px;\n  }\n  \n  .view-mode-btn {\n    font-size: 11px;\n    padding: 10px 6px;\n  }\n  \n  .progress-summary {\n    grid-template-columns: 1fr;\n  }\n  \n  .extra-payment-section {\n    margin: 12px;\n    padding: 20px 16px;\n  }\n  \n  .extra-payment-section h3 {\n    font-size: 16px;\n  }\n  \n  .debt-cards {\n    padding: 0 12px;\n  }\n  \n  .debt-card {\n    padding: 20px 16px;\n  }\n  \n  .debt-card-header h3 {\n    font-size: 16px;\n  }\n  \n  .empty-state {\n    padding: 40px 16px;\n  }\n  \n  .empty-state h3 {\n    font-size: 18px;\n  }\n  \n  .empty-state p {\n    font-size: 14px;\n  }\n}\n\n/* Dark Mode Support */\n.dark-mode .debt-snowball {\n  background: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);\n}\n\n.dark-mode .debt-header {\n  background: linear-gradient(135deg, #422749 0%, #200f2a 100%);\n}\n\n.dark-mode .debt-header h1 {\n\tcolor: white !important;\n}\n\n.dark-mode .summary-card,\n.dark-mode .extra-payment-section,\n.dark-mode .debt-card {\n  background: var(--white);\n  border-color: var(--gray-200);\n}\n\n.dark-mode .input-with-symbol {\n  background: var(--gray-100);\n  border-color: var(--gray-200);\n}\n\n.dark-mode .input-with-symbol span {\n  background: var(--gray-200);\n}\n\n.dark-mode .dialog-content {\n  background: var(--white);\n}\n\n.dark-mode .dialog-content input,\n.dark-mode .dialog-content select {\n  background: var(--gray-50);\n  border-color: var(--gray-200);\n}\n\n.dark-mode .bill-checkbox {\n  background: var(--gray-100);\n}\n\n.dark-mode .bill-checkbox:hover {\n  background: var(--gray-200);\n}\n\n.dark-mode .schedule-month {\n  background: var(--gray-100);\n  border-color: var(--gray-200);\n}\n\n.dark-mode .schedule-debt {\n  background: var(--gray-50);\n  border-color: var(--gray-200);\n}\n\n.dark-mode .view-mode-selector {\n  background: var(--gray-200);\n}\n\n.dark-mode .view-mode-btn {\n  color: var(--gray-700);\n}\n\n.dark-mode .view-mode-btn:hover {\n  background: var(--gray-300);\n  color: var(--gray-800);\n}\n\n.dark-mode .timeline-debt-info,\n.dark-mode .debt-progress-item,\n.dark-mode .enhanced-schedule-month {\n  background: var(--white);\n  border-color: var(--gray-200);\n}\n\n.dark-mode .progress-stat,\n.dark-mode .list-summary .summary-item {\n  background: var(--gray-100);\n  border-color: var(--gray-200);\n}\n\n.dark-mode .chart-area {\n  background: var(--gray-100);\n  border-color: var(--gray-200);\n}\n\n.dark-mode .debt-payment-details {\n  background: var(--gray-100);\n  border-color: var(--gray-200);\n}\n\n.dark-mode .enhanced-schedule-month .month-header {\n  background: var(--gray-100);\n  border-color: var(--gray-200);\n}\n\n/* Animation for debt card entry */\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.debt-card {\n  animation: slideInUp 0.3s ease-out;\n}\n\n/* Print Styles */\n@media print {\n  .debt-header,\n  .action-buttons,\n  .debt-actions,\n  .edit-button,\n  .remove-button {\n    display: none !important;\n  }\n  \n  .debt-snowball {\n    background: var(--white);\n    margin: 0;\n    padding: 20px;\n  }\n  \n  .debt-summary {\n    margin-top: 0;\n  }\n  \n  .debt-card {\n    break-inside: avoid;\n    page-break-inside: avoid;\n    box-shadow: none;\n    border: 1px solid var(--gray-300);\n    margin-bottom: 20px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
